
import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../Button";
import { ChevronDown, ChevronUp } from "lucide-react";
import { cn } from "@/lib/utils";

interface MobileMenuProps {
  isMobileMenuOpen: boolean;
  toggleMobileMenu: () => void;
}

const MobileMenu = ({ isMobileMenuOpen, toggleMobileMenu }: MobileMenuProps) => {
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isExpertiseOpen, setIsExpertiseOpen] = useState(false);

  return (
    <div
      className={cn(
        "fixed inset-0 bg-background/95 backdrop-blur-sm z-40 transition-transform duration-300 transform md:hidden overflow-y-auto pt-20",
        isMobileMenuOpen ? "translate-y-0" : "-translate-y-full"
      )}
    >
      <div className="container mx-auto py-8 px-6">
        <nav className="flex flex-col space-y-6">
          {/* Services Dropdown */}
          <div>
            <button
              onClick={() => setIsServicesOpen(!isServicesOpen)}
              className="flex items-center justify-between w-full text-xl font-medium text-white py-2"
            >
              <span>Services</span>
              {isServicesOpen ? (
                <ChevronUp className="h-5 w-5" />
              ) : (
                <ChevronDown className="h-5 w-5" />
              )}
            </button>
            {isServicesOpen && (
              <div className="mt-2 ml-4 flex flex-col space-y-3">
                <Link
                  to="/services/training"
                  onClick={toggleMobileMenu}
                  className="text-white/70 hover:text-white"
                >
                  Training
                </Link>
                <Link
                  to="/services/strategy"
                  onClick={toggleMobileMenu}
                  className="text-white/70 hover:text-white"
                >
                  Strategy
                </Link>
                <Link
                  to="/services/advisory"
                  onClick={toggleMobileMenu}
                  className="text-white/70 hover:text-white"
                >
                  Advisory
                </Link>
                <Link
                  to="/services/custom-solutions"
                  onClick={toggleMobileMenu}
                  className="text-white/70 hover:text-white"
                >
                  Custom Solutions
                </Link>
              </div>
            )}
          </div>

          {/* Expertise Dropdown */}
          <div>
            <button
              onClick={() => setIsExpertiseOpen(!isExpertiseOpen)}
              className="flex items-center justify-between w-full text-xl font-medium text-white py-2"
            >
              <span>Expertise</span>
              {isExpertiseOpen ? (
                <ChevronUp className="h-5 w-5" />
              ) : (
                <ChevronDown className="h-5 w-5" />
              )}
            </button>
            {isExpertiseOpen && (
              <div className="mt-2 ml-4 grid grid-cols-1 gap-3">
                <Link
                  to="/expertise/contract-lifecycle"
                  onClick={toggleMobileMenu}
                  className="text-white/70 hover:text-white"
                >
                  Contract Lifecycle
                </Link>
                <Link
                  to="/expertise/case-management"
                  onClick={toggleMobileMenu}
                  className="text-white/70 hover:text-white"
                >
                  Case Management
                </Link>
                <Link
                  to="/expertise/document-analysis"
                  onClick={toggleMobileMenu}
                  className="text-white/70 hover:text-white"
                >
                  Document Analysis
                </Link>
                <Link
                  to="/expertise/litigation"
                  onClick={toggleMobileMenu}
                  className="text-white/70 hover:text-white"
                >
                  Litigation
                </Link>
                <Link
                  to="/expertise/compliance"
                  onClick={toggleMobileMenu}
                  className="text-white/70 hover:text-white"
                >
                  Compliance
                </Link>
                <Link
                  to="/expertise/transactions"
                  onClick={toggleMobileMenu}
                  className="text-white/70 hover:text-white"
                >
                  Transactions
                </Link>
                <Link
                  to="/expertise/client-management"
                  onClick={toggleMobileMenu}
                  className="text-white/70 hover:text-white"
                >
                  Client Management
                </Link>
                <Link
                  to="/expertise/practice-management"
                  onClick={toggleMobileMenu}
                  className="text-white/70 hover:text-white"
                >
                  Practice Management
                </Link>
              </div>
            )}
          </div>

          <Link
            to="/about-us"
            onClick={toggleMobileMenu}
            className="text-xl font-medium text-white py-2"
          >
            About Us
          </Link>

          <div className="pt-4">
            <Link to="/contact" onClick={toggleMobileMenu} className="w-full block">
              <Button
                variant="default"
                size="lg"
                className="w-full"
                hasAnimation={true}
              >
                Contact Us
              </Button>
            </Link>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;
